import {Loading, Toast} from 'zarm';
/**
 * 格式化数据
 */
export const format = {
  done(rule, value) {
    const {
      range = [-Infinity, Infinity],
      fixed,
      reg,
      replacement,
      min: minValue,
    } = rule;
    // 是不是有符号位
    const isSymbol = /(\-|\+)/.test(value);
    // // 转换为数字
    value = value && typeof +value === 'number' ? +value : '';
    // 判断数字范围
    const [min, max] = range;
    if (!(value < min || value > max)) {
      // 判断是否需要保留两位小数
      if (rule.fixed && `${value}`) {
        value = value.toFixed(rule.fixed);
      }
      // 是否需要格式化
      // 如果大于0需要格式化, 且不带正负号
      if (value > 0 && !/(\-|\+)/.test(value) && replacement) {
        value = replacement?.replace('#{value}', value);
      }
    }
    if (value < min || value > max) {
      value = '';
      Toast.show({
        content: `请输入[${min}, ${max}]范围的数据`,
        stayTime: 500,
      });
    }
    if (value < minValue) {
      value = '';
      Toast.show({
        content: `请输入大于${minValue - 1}的数据`,
        stayTime: 500,
      });
    }
    if (reg && !eval(reg).test(value)) {
      Toast.show({
        content: `请输入正确格式的数据`,
        stayTime: 500,
      });
      value = '';
    }
    value = isNaN(value) ? '' : value;
    return value;
  },
};
